module.exports = __webpack_public_path__ + "img/Homebodybg.dc0dbc8a.png";